import { render, staticRenderFns } from "./NotificationCreate.vue?vue&type=template&id=12b1f162&"
import script from "./NotificationCreate.vue?vue&type=script&lang=js&"
export * from "./NotificationCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports